import { Tab } from "@mui/material";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { CustomTabs } from '../../../components/Forms/CustomTabs';
import RessourceMenu from "../../../components/RessourceMenu";
import TabPanel from "../../../components/TabPanel";
import Portalias from "../../../models/Portalias";
import { PermissionEnum } from '../../Permission/PermissionEnum';
import { AbilityContext } from '../../UserApi/logic/Can';
import { useDeletePortaliasMutation, useGetPortaliasByIdQuery } from "../redux/portaliasApiSlice";
import ACLTab from "./tabs/ACLTab";
import InfoTab from "./tabs/InfoTab";

interface PortaliasInfoDialogProps {
    portalias: Portalias
    afterDeleteAction?: () => void
}

export const PortaliasInfoDialog = (props: PortaliasInfoDialogProps) => {

    const [value, setValue] = React.useState(0);
    const { t } = useTranslation()
    const { data } = useGetPortaliasByIdQuery(props.portalias.uuid!)
    const ability = useContext(AbilityContext)
    const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    if (data == undefined)
        return <></>

    const labels = []
    const tabPanel = []

    labels.push(t("Info") + "")
    tabPanel.push(<TabPanel value={value} index={tabPanel.length}><InfoTab portaliasId={data.uuid!} isPortaliasInUse={data.in_use!} {...props} /></TabPanel>)
    labels.push(t("ACL") + "")
    tabPanel.push(<TabPanel value={value} index={tabPanel.length}><ACLTab portaliasId={data.uuid!} isPortaliasInUse={data.in_use!} {...props} /></TabPanel>)

    return (
        <>

            <CustomTabs value={value} onChange={handleChange} rightMenu={
                <RessourceMenu
                    isAllowedToDelete={(data) => ability.can(PermissionEnum.GOD, data) && !data.in_use}
                    nameOfRessource="portalias"
                    primaryButtonText={t("Portalias") + ": " + data.name}
                    idToFetch={data.uuid}
                    deleteMutation={useDeletePortaliasMutation}
                    getByIdAction={useGetPortaliasByIdQuery}
                    afterDeleteAction={props.afterDeleteAction} />}>
                {labels.map(label => (<Tab key={label} label={label} />))}
            </CustomTabs>

            {tabPanel.map(tabPanel => tabPanel)}
        </>
    )
}